import * as React from "react";
const SvgQuestion = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M14.4001 7.99996C14.4001 11.5346 11.5347 14.4 8.0001 14.4C4.46547 14.4 1.6001 11.5346 1.6001 7.99996C1.6001 4.46535 4.46547 1.59998 8.0001 1.59998C11.5347 1.59998 14.4001 4.46535 14.4001 7.99996ZM8.35464 9.78407H7.0626C6.99782 8.61134 7.31828 8.13748 7.95919 7.73861C8.40919 7.46248 8.70237 7.16929 8.70237 6.73975C8.70237 6.26588 8.33078 5.95907 7.87055 5.95907C7.42396 5.95907 7.01146 6.25566 6.99101 6.81134H5.6001C5.63078 5.4477 6.63987 4.79998 7.87737 4.79998C9.23078 4.79998 10.1921 5.49543 10.1921 6.68861C10.1921 7.42838 9.83078 7.94316 9.20351 8.32838C8.57282 8.71702 8.35464 8.97611 8.35464 9.78407ZM8.55237 11.1477C8.54896 11.6011 8.17055 11.9659 7.73419 11.9659C7.28419 11.9659 6.9126 11.6011 6.91601 11.1477C6.9126 10.7011 7.28419 10.3363 7.73419 10.3363C8.17055 10.3363 8.54896 10.7011 8.55237 11.1477Z"
}));
export default SvgQuestion;
